"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigSortableListItem = exports.ConfigSortableList = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@dnd-kit/core");
const sortable_1 = require("@dnd-kit/sortable");
const utilities_1 = require("@dnd-kit/utilities");
const core_2 = require("@material-ui/core");
const ConfigList_1 = require("./ConfigList");
const StyledConfigList = (0, styled_components_1.default)(ConfigList_1.ConfigList) `
  .drag-indicator {
    cursor: grab;
    margin-left: -2px;
    color: #ccc;
  }
`;
const StyledConfigListItem = (0, styled_components_1.default)(ConfigList_1.ConfigListItem) `
  &.dragging {
    opacity: 0.8;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
      0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  }
`;
/**
 * Generic implementation of the ConfigList with sortable list items using
 * dnd-kit.
 */
const ConfigSortableList = ({ data, footer, onMove, onDelete, renderItem, keyIndicator }) => {
    const [list, setList] = (0, react_1.useState)([]);
    const [drag, setDrag] = (0, react_1.useState)();
    // update list if data props changes
    (0, react_1.useEffect)(() => {
        // create an abritrary item id using index
        setList(list => {
            console.log('refresh list', data, list);
            if (
            // refresh list if array length changed
            data.length !== list.length ||
                // refresh list if list items have changed; need this to prevent list
                // from refreshing right after onDragEnd event causing dnd-kit to match
                // wrong item in list when animating the dragged item.
                data.some((d, index) => { var _a; return ((_a = list[index]) === null || _a === void 0 ? void 0 : _a.value) !== d; })) {
                return data.map((value, index) => ({ id: index.toString(), value }));
            }
            else {
                return list;
            }
        });
        // include both `data` and `data.length` in case data is mutated when items
        // are inserted or deleted
    }, [data, data.length]);
    const sensors = (0, core_1.useSensors)((0, core_1.useSensor)(core_1.PointerSensor));
    return (react_1.default.createElement(core_1.DndContext, { sensors: sensors, onDragStart: ({ active }) => {
            const item = list.find(item => active.id === item.id);
            if (item) {
                setDrag(item);
            }
        }, onDragEnd: ({ active, over }) => {
            if (active.id === (over === null || over === void 0 ? void 0 : over.id))
                return;
            const sourceIndex = list.findIndex(item => active.id === item.id);
            const targetIndex = list.findIndex(item => (over === null || over === void 0 ? void 0 : over.id) === item.id);
            setList(list => {
                return (0, sortable_1.arrayMove)(list, sourceIndex, targetIndex);
            });
            onMove === null || onMove === void 0 ? void 0 : onMove(sourceIndex, targetIndex);
        } },
        react_1.default.createElement(sortable_1.SortableContext, { items: list.map(item => item.id), strategy: sortable_1.verticalListSortingStrategy },
            react_1.default.createElement(StyledConfigList, { className: 'config-sortable-list' },
                list.map((item, index) => {
                    return (react_1.default.createElement(exports.ConfigSortableListItem, { key: keyIndicator ? keyIndicator(item.value, index) : item.id, hover: true, itemId: item.id, icon: react_1.default.createElement(core_2.Icon, { className: 'drag-indicator' }, "drag_indicator"), primary: renderItem(item.value, index), secondaryAction: onDelete && (react_1.default.createElement(core_2.IconButton, { size: 'small', onClick: e => {
                                e.stopPropagation();
                                onDelete === null || onDelete === void 0 ? void 0 : onDelete(index);
                            } },
                            react_1.default.createElement(core_2.Icon, null, "remove_circle_outline"))) }));
                }),
                footer && react_1.default.createElement(ConfigList_1.ConfigListItem, null, footer))),
        react_1.default.createElement(core_1.DragOverlay, null, drag ? (react_1.default.createElement(exports.ConfigSortableListItem, { icon: react_1.default.createElement(core_2.Icon, { className: 'drag-indicator' }, "drag_indicator"), className: 'dragging', primary: renderItem(drag.value, data.findIndex((item) => item.id === drag.id)), secondaryAction: react_1.default.createElement(core_2.IconButton, { size: 'small' },
                react_1.default.createElement(core_2.Icon, null, "remove_circle_outline")) })) : null)));
};
exports.ConfigSortableList = ConfigSortableList;
const ConfigSortableListItem = (_a) => {
    var { itemId } = _a, props = __rest(_a, ["itemId"]);
    const { attributes, listeners, setNodeRef, transform, transition } = (0, sortable_1.useSortable)({ id: itemId || '' });
    return (react_1.default.createElement(StyledConfigListItem, Object.assign({ ref: setNodeRef, className: 'sortable', style: {
            // opacity: isDragging ? 0.75 : undefined,
            transform: utilities_1.CSS.Translate.toString(transform),
            transition: transition || undefined
        }, iconProps: Object.assign(Object.assign({}, attributes), listeners) }, props)));
};
exports.ConfigSortableListItem = ConfigSortableListItem;
exports.default = exports.ConfigSortableList;
//# sourceMappingURL=ConfigSortableList.js.map